export default {
  'aiSkills.form.packageName': 'Package Name',
  'aiSkills.form.packageName.pattern':
    'Lowercase letters, numbers and hyphens only. No leading/trailing or consecutive hyphens.',
  'aiSkills.form.compatibility': 'Compatibility',
  'aiSkills.form.instructions': 'Instructions',
  'aiSkills.form.instructions.edit': 'Edit Instructions',
  'aiSkills.form.instructions.placeholder.expanded':
    'Write detailed instructions for this skill...',
  'aiSkills.form.allowedTools': 'Allowed Tools',
  'aiSkills.form.group': 'Group',
  'aiSkills.form.scripts': 'Scripts',
  'aiSkills.form.references': 'References',
  'aiSkills.form.assets': 'Assets',
  'aiSkills.form.isManaged': 'Is Managed',
  'aiSkills.form.published': 'Published',
  'aiSkills.form.publisher': 'Publisher',
  'aiSkills.form.publishedDate': 'Published Date',
  'aiSkills.form.sourceProvider': 'Source Provider',
  'aiSkills.form.zipContent': 'ZIP File',
  'aiSkills.form.githubTreeUrl': 'GitHub tree URL',
  'aiSkills.status.published': 'Published',
  'aiSkills.status.unpublished': 'Unpublished',
  'aiSkills.sourceProvider.manual': 'Manual',
  'aiSkills.sourceProvider.git': 'Git',
  'aiSkills.sourceProvider.zip': 'Zip',
  'aiSkills.import.title': 'Import',
  'aiSkills.import.preview': 'Preview',
  'aiSkills.import.preview.owner': 'Owner',
  'aiSkills.import.preview.license': 'License',
  'aiSkills.import.dragOrClick': 'Drag and drop or click to replace',
  'aiSkills.import.selectZip': 'Please select a ZIP file',
};
